@if (connectsDataSource | async) {
<form class="d-flex search">
  <input
    class="form-control me-2"
    type="search"
    placeholder="Search"
    name="searchName"
    [(ngModel)]="searchName"
    #search="ngModel"
    (keyup)="getConnects()"
    (keydown.enter)="getConnects()"
    aria-label="Search"
  />
</form>

@for (item of connects; track $index) {
<div class="container w mt-5">
  <div
    class="card card-custom"
    [ngClass]="{ 'card-custom-complete': item.connectStatus }"
  >
    <div class="d-flex align-items-center mb-2">
      <div class="icon">
        <span>&#9733;</span>
      </div>
      <div class="header">
        <div class="title">{{ item.firstName }} {{ item.lastName }}</div>
        @if (item.connectStatus) {
        <div class="title">Complete</div>
        }@else {
        <div class="title">Pending</div>
        }
      </div>
    </div>
    <div class="price">Country: {{ item.country }}</div>
    <div class="details">Mobile: 0{{ item.phone }}</div>
    <div class="details">Email: {{ item.email }}</div>
    <div class="d-flex flex-row justify-content-between">
      <div class="details">Reason: {{ item.reason }}</div>
      @if (item.connectStatus) {
      <button
        type="button"
        class="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#adminDetails"
        (click)="adminDetails(item)"
      >
        Connected
      </button>
      }@else {
      <button
        type="button"
        class="btn btn-danger"
        data-bs-toggle="modal"
        data-bs-target="#check"
        (click)="adminDetails(item)"
      >
        Enter Admin Info
      </button>
      }
    </div>

    <div class="details">
      Departure Date: <b>{{ item.departureDate | date }}</b>
    </div>
  </div>
</div>
}
<nav aria-label="Page navigation example">
  <ul class="pagination justify-content-end">
    <li class="page-item" [ngClass]="{ disabled: page === 1 }">
      <a
        class="page-link"
        (click)="previous()"
        (keydown)="previous()"
        tabindex="-1"
        >Previous</a
      >
    </li>
    @for (item of pageNumbers; track $index) {
    <li class="page-item" [ngClass]="{ active: item === page }">
      <a
        class="page-link"
        (click)="getPage(item)"
        (keydown)="getPage(item)"
        tabindex="0"
        >{{ item }}</a
      >
    </li>
    }
    <li class="page-item" [ngClass]="{ disabled: page === totalPages }">
      <a class="page-link" (click)="next()" (keyup.enter)="next()" tabindex="0"
        >Next</a
      >
    </li>
  </ul>
</nav>

<div
  class="modal fade"
  id="check"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Admin Check In</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form #leadershipForm="ngForm">
          <div class="mb-3">
            <label for="mobile" class="form-label">Name</label>
            <input
              class="form-control"
              type="text"
              id="adminFullName"
              name="adminFullName"
              [(ngModel)]="connect.adminFullName"
              #adminFullName="ngModel"
            />
          </div>
          <div class="mb-3">
            <label for="mobile" class="form-label">Email</label>
            <input
              class="form-control"
              type="email"
              id="adminEmail"
              name="adminEmail"
              [(ngModel)]="connect.adminEmail"
              #adminEmail="ngModel"
            />
          </div>

          <div class="mb-3">
            <label for="mobile" class="form-label">Check In Date</label>
            <input
              class="form-control"
              type="date"
              id="title"
              name="title"
              [(ngModel)]="connect.checkInDate"
              #checkInDate="ngModel"
            />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          data-bs-dismiss="modal"
          [disabled]="!leadershipForm.valid"
          (click)="onSubmit()"
        >
          Check Complete
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="adminDetails"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Admin Check Details</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Connect Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ connect.adminFullName }}</td>
              <td>{{ connect.adminEmail }}</td>
              <td>
                <b>{{ connect.checkInDate | date : "MMM dd, yyyy" }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

}@else {
<div class="d-flex justify-content-center">
  <div class="spinner-border" aria="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
}
